import {useEffect, useRef, useMemo} from 'react';
import {Chart} from 'primereact/chart';
import {useNavigate} from "react-router-dom";

type Props = {
    buyers:  number;
    sellers: number;
    admins:  number;
};

const OPTIONS = {
    plugins: {legend: {labels: {color: '#495057'}}},
};

const SystemUsersPieChart = ({buyers, sellers, admins}: Props) => {
    const navigate  = useNavigate();
    const chartRef  = useRef<any>(null);

    useEffect(() => () => { try { chartRef.current?.getChart?.()?.destroy(); } catch(_){} }, []);

    const chartData = useMemo(() => ({
        labels: ['Buyers', 'Sellers', 'Admins'],
        datasets: [{
            data: [buyers, sellers, admins],
            backgroundColor:      ['#42A5F5', '#66BB6A', '#FFA726'],
            hoverBackgroundColor: ['#64B5F6', '#81C784', '#FFB74D'],
        }],
    }), [buyers, sellers, admins]);

    const options = useMemo(() => ({
        ...OPTIONS,
        onClick(_evt: any, items: any[]) {
            if (!items?.length) return;
            const routes = ['/buyers', '/shops', '/profile'];
            navigate(routes[items[0].index] ?? '/home');
        },
    }), [navigate]);

    return (
        <div className="card flex justify-content-center align-items-center">
            <Chart ref={chartRef} type="pie" data={chartData} options={options} style={{width:'80%'}}/>
        </div>
    );
};

export default SystemUsersPieChart;
